import { DateTime, FixedOffsetZone, type ToRelativeUnit } from 'luxon';

export const timeElapsed = (datetime: DateTime): ToRelativeUnit => {
    const now = DateTime.fromMillis(Date.now(), { zone: FixedOffsetZone.utcInstance });
    const ago = now.diff(datetime, ['days', 'hours', 'minutes', 'seconds']);

    switch (true) {
        case ago.days >= 1:
            return 'days';
        case ago.hours > 1:
            return 'hours';
        case ago.minutes >= 1:
            return 'minutes';
        case ago.minutes < 1 && ago.minutes > 0:
            return 'seconds';
        default:
            return 'days';
    }
};
